import React from 'react'
import { getHexColor, OneColorIconProps } from '@/atoms/utils'

export const VideoCameraOutlineIcon: React.FC<OneColorIconProps> = ({ color = 'white', size = 16, className }) => {
  const c1 = getHexColor(color)

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 49"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.3044 11.7188H5.34784C4.45993 11.7188 3.6084 12.0437 2.98056 12.6223C2.35272 13.2008 2 13.9854 2 14.8035V30.6679C2 32.5379 2.80621 34.3313 4.24128 35.6536C5.67634 36.9759 7.62271 37.7188 9.6522 37.7188H32.6088C33.4967 37.7188 34.3482 37.3938 34.9761 36.8153C35.6039 36.2367 35.9566 35.4521 35.9566 34.634V30.4004L43.1379 34.1815C43.73 34.4933 44.4574 34.491 45.0472 34.1757C45.637 33.8603 46.0001 33.2794 46.0001 32.6511V16.7867C46.0001 16.1583 45.637 15.5775 45.0472 15.2621C44.4574 14.9467 43.73 14.9445 43.1379 15.2562L35.9566 19.0373V18.7696C35.9566 16.8996 35.1504 15.1062 33.7154 13.7839C32.2803 12.4616 30.3339 11.7188 28.3044 11.7188ZM32.1305 22.0402C32.13 22.0643 32.13 22.0885 32.1305 22.1127V27.3251C32.13 27.3493 32.13 27.3734 32.1305 27.3975V34.1933H9.6522C8.63745 34.1933 7.66427 33.8219 6.94674 33.1608C6.2292 32.4996 5.8261 31.6029 5.8261 30.6679V15.2442H28.3044C29.3192 15.2442 30.2924 15.6156 31.0099 16.2767C31.7274 16.9379 32.1305 17.8346 32.1305 18.7696V22.0402ZM35.9566 26.34V23.0977L42.174 19.8241V29.6136L35.9566 26.34Z"
        fill={c1}
      />
    </svg>
  )
}
